import React from 'react'
import '../styles/MemberDetails.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../components/SideBar';
import '../styles/WalletPage.css';
import cash from'../assets/images/tc-cash-wallet 1.png';
import units from'../assets/images/tc-units-wallet 2.png';


function MemberWalletPage() {
    const location = useLocation();
    const member = location.state?.member;
    const navigate = useNavigate();

    const goToWallet = () => {
      navigate('/member-wallet-details', {state: {member}})
    }

    const goToRequestHistory = () => {
        navigate('/member-cash-request-history', {state: {member}})
    }

    const goToMemberDetails = () => {
        navigate('/member-details', {state: {member}})
    }

    console.log("Received customer:", member);

  return (
    <div className="member-details-layout">
      <SideBar />

        <div className="member-details-main">

            {/* Header */}
            <div className="details-header">
                <h2>Member Details</h2>
                <p>You can edit your details to update your profile</p>
            </div>

            {/* Breadcrumb */}
            <div className="breadcrumb">
                <Link to="/dashboard" className="breadcrumb-link">Home</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <Link to="/manage-member" className="breadcrumb-link">Manage Member</Link>
                <span className="breadcrumb-separator">{">"}</span>
                <span className="breadcrumb-current">Member Details</span>
            </div>

            {/* buttons */}
            <div className="top-bar">
            {/* tap buttons */}
                <div className="top-buttons">
                    <button className="tab-btn" onClick={goToMemberDetails}>Personal Details</button>
                    <button className="tab-btn active" onClick={goToWallet}>Wallet Details</button>
                    <button className="tab-btn" onClick={goToRequestHistory}>Cash Request History</button>
                </div>
            </div>

            {/* Wallet Section */}
            <div className="wallet-section">
                <div className="wallet-card">
                    <h3>TCUK TopCoin Wallet</h3>
                    <img src={units} alt="Units Wallet" className="wallet-img" />
                    <p className="balance-label">Available Balance</p>
                    <h2 className="balance-value">{member?.value || "0 units"}</h2>
                    <Link to="/member-units-transaction-history" state={{member}} className="wallet-link">
                    Transaction History &gt;&gt;
                    </Link>
                </div>

                <div className="wallet-card">
                    <h3>TCUK Cash Wallet</h3>
                    <img src={cash} alt="Cash Wallet" className="wallet-img" />
                    <h2 className="balance-value">N/A</h2>
                </div>
            </div>
        </div>       
    </div>
  )
}

export default MemberWalletPage